import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { updateCart } from "../../../../v1/actions/user"
import {
  getCustomServiceCategories,
  getWalkinServiceCategories
} from "../../../../v1/actions/services"
import { ShimmerServiceCard } from "../../Services/ShimmerServiceCard"
import { Button, Card, Divider, Header, Input, Icon } from "semantic-ui-react"
import ServiceCategoryCard from "./ServiceCategoryCard"
import CategoryServices from "./CategoryServices"
import { routerPaths } from "../../../../v1/constants/paths"
import { withRouter } from "react-router-dom"
import { useTranslation } from "react-i18next"
import {
  gaJSON,
  trackFirebaseAnalytics
} from "../../../../shared_component/utils/googleAnalyticsHelpers"
import LetsScheduleAppointmentModal from "../LetsScheduleAppointmentModal"
import { serviceRequestTypes } from "../../../constants"
import store from "../../../../shared_component/utils/configureStore"
import Notifications from "../../../../v1/components/Notifications"
import { CA } from "../../../../v1/constants/states"

const SelectService = (props) => {
  const [serviceCategories, setServiceCategories] = useState([])
  const [walkInServices, setWalkInServices] = useState([])
  const [isLoading, setLoading] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [openLetsSchedule, setOpenLetsSchedule] = useState(false)
  const {
    cart,
    getCustomServiceCategories,
    getWalkinServiceCategories,
    history,
    location,
    user
  } = props
  const { t } = useTranslation("addService")

  const fetchAvailableCategories = async () => {
    setLoading(true)
    let categories = {}
    let categoryServices = null

    if (cart.cart_type === serviceRequestTypes.WALK_IN) {
      categories = (await getWalkinServiceCategories()) || null
      if (Array.isArray(categories)) {
        categories = [...categories].sort((a, b) => {
          if (a.name === "Oil Change") return -1
          if (b.name === "Oil Change") return 1
          return 0
        })
      }
      categoryServices = categories ?? []
      setWalkInServices(categories)
    } else {
      categories = (await getCustomServiceCategories()) || null
      categoryServices =
        categories?.flatMap((item) => [...item.default, ...item.related_services]) ?? []
    }

    if (categories !== null) {
      setServiceCategories(categories)
    }

    if (categoryServices.length > 0) {
      const allServiceIds = new Set(categoryServices.map((service) => service.id))
      const filteredServices = cart.order_services.filter(
        (service) => !allServiceIds.has(service.id)
      )
      if (filteredServices.length > 0) {
        const otherCategory = {
          category: "Other services",
          default: filteredServices
        }
        categories.unshift(otherCategory)
        setServiceCategories(categories)
      }
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchAvailableCategories()
  }, [cart.cart_type])

  useEffect(() => {
    const unblock = history.block((location) => {
      if (location.pathname === routerPaths.reviewServices) {
        return true
      }
      if (selectedCategory) {
        setSelectedCategory(null)
        return false
      }
    })
    return () => {
      unblock()
    }
  }, [history, selectedCategory, cart])

  const handleSubmit = async () => {
    if (location.state?.fromReviewRequest) {
      history.push(routerPaths.reviewRequest)
      return
    }
    if (user.country === CA) {
      history.push(routerPaths.selectDate)
      return
    }
    history.push({
      pathname: routerPaths.shopSelection
    })
  }

  const handleSearchClick = async () => {
    history.push({
      pathname: routerPaths.searchService
    })
  }

  const handleServiceType = async (serviceType) => {
    const { activeVehicle } = props
    setLoading(true)
    try {
      setOpenLetsSchedule(false)
      await store.dispatch(updateCart(null, activeVehicle.id, null, undefined, {}, serviceType))
      trackFirebaseAnalytics({
        event: gaJSON.pivot_modal_interaction,
        params: {
          user_choice: "switch_to_scheduled"
        }
      })
      setLoading(false)
    } catch (e) {
      setOpenLetsSchedule(false)
      store.dispatch(
        Notifications.error({
          title: t("errorLbl"),
          message: e.toString(),
          position: "tr",
          autoDismiss: 5,
          action: {
            label: "Dismiss"
          }
        })
      )
      setLoading(false)
    }
  }

  const handleCategoryCardClick = (category) => {
    setSelectedCategory(category)
  }

  const handleCancel = () => {
    setSelectedCategory(null)
  }

  if (cart.cart_type === serviceRequestTypes.WALK_IN && !isLoading && walkInServices.length > 0) {
    return (
      <>
        <Card className="service-card" raised={true}>
          {isLoading && <ShimmerServiceCard count={5} />}
          <Header as="h4">Select a Service</Header>
          <Input iconPosition="left" placeholder="Search for a service">
            <Icon name="search" />
            <input onClick={handleSearchClick} />
          </Input>
          <div className="appointment-modal-info">
            This list features shops that specialize in express services. Looking for a full-service
            center?{" "}
            <p className="appointment-modal" onClick={() => setOpenLetsSchedule(true)}>
              Schedule an appointment.
            </p>
          </div>
          <CategoryServices
            firstLevelCategory={""}
            defaultServices={walkInServices || []}
            relatedServices={[]}
            handleShowReviewServices={() => {
              history.push({
                pathname: routerPaths.reviewServices,
                state: location.state
              })
            }}
            handleCancel={handleCancel}
            toggleService={toggleService}
          />
        </Card>

        <LetsScheduleAppointmentModal
          open={openLetsSchedule}
          onClose={() => setOpenLetsSchedule(false)}
          continueSchedule={() => handleServiceType(serviceRequestTypes.SCHEDULE_SERVICE)}
        />
      </>
    )
  }

  if (selectedCategory) {
    const service = serviceCategories.find((service) => service.category === selectedCategory)
    return (
      <CategoryServices
        firstLevelCategory={selectedCategory}
        defaultServices={service.default || []}
        relatedServices={service.related_services || []}
        handleShowReviewServices={() => {
          history.push({
            pathname: routerPaths.reviewServices,
            state: location.state
          })
        }}
        handleCancel={handleCancel}
        toggleService={toggleService}
      />
    )
  }

  return (
    <>
      <Card className="service-card" raised={true}>
        <Header as="h4">Select a Category</Header>
        <Input iconPosition="left" placeholder="Search for a service">
          <Icon name="search" />
          <input onClick={handleSearchClick} />
        </Input>
        {isLoading && <ShimmerServiceCard count={5} />}
        {!isLoading &&
          serviceCategories.length > 0 &&
          serviceCategories.map((service, index) => {
            let serviceCount = 0
            const defaultServices = service.default || []
            const relatedServices = service.related_services || []
            const allCategoryServiceIds = [
              ...defaultServices.map((s) => s.id),
              ...relatedServices.map((s) => s.id)
            ]
            if (service.category === "Oil Change") {
              serviceCount = cart.order_services.filter(
                (order_service) => order_service.id == defaultServices[0].id
              ).length
            } else {
              serviceCount = cart.order_services.filter((order_service) =>
                allCategoryServiceIds.includes(order_service.id)
              ).length
            }
            return (
              <>
                <ServiceCategoryCard
                  key={service.category}
                  index={index}
                  categoryName={service.category}
                  serviceCount={serviceCount}
                  description={service.description || ""}
                  handleCategoryCardClick={handleCategoryCardClick}
                />
                {index != serviceCategories.length - 1 && <Divider fitted />}
              </>
            )
          })}
      </Card>
      <Card className="service-card" raised={true} style={{ padding: "8px 16px" }}>
        <ServiceCategoryCard
          key="search-all-services"
          categoryName={"Search all services"}
          serviceCount={0}
          description=""
          handleCategoryCardClick={() =>
            history.push({
              pathname: routerPaths.searchService
            })
          }
        />
      </Card>
      {cart.order_services.length > 0 && (
        <Card className="service-card" raised={true} style={{ padding: 0 }}>
          <div className="action_button padding-12">
            <Button fluid onClick={handleSubmit} className="primary-button">
              {location.state?.fromReviewRequest
                ? "Confirm and Continue"
                : t("ContinueToSelectShop")}
            </Button>
          </div>
        </Card>
      )}
    </>
  )
}

function mapStateToProps(state, props) {
  let user = state.user || {}
  let cart
  let currentActiveOrder =
    user.active_orders && user.active_orders.find((o) => o.vehicle_id == user.activeVehicleId)
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id == user.activeVehicleId)

  if (currentActiveOrder) {
    cart = currentActiveOrder
  } else {
    if (props.cartId) {
      cart = user.active_carts && user.active_carts.filter((c) => c.id == Number(props.cartId))[0]
    } else {
      cart =
        user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)
    }
  }

  if (!cart || !cart.order_services) {
    cart = { estimated_total: 0, order_services: [] }
  }

  return {
    cart: cart,
    user: user,
    activeVehicle
  }
}

export const toggleService = async ({
  service,
  positionOverride = null,
  cart,
  order,
  vehicle,
  selectedPositions,
  setSelectedPositions,
  setServiceErrors,
  setServicesUpdating,
  setSelectedServices,
  t,
  updateCart
}) => {
  const isSelected = cart.order_services.some(
    (item) => item.service_definition_id === service.service_id || item.id === service.id
  )
  const position = positionOverride ?? selectedPositions[service.id] ?? null
  if (positionOverride !== null && !isSelected) {
    setServiceErrors((prev) => {
      const { [service.id]: removed, ...rest } = prev
      return rest
    })
    setSelectedPositions((prev) => ({ ...prev, [service.id]: position }))
    return
  }
  if (!isSelected && !position && service.positions && service.positions.length > 0) {
    setServiceErrors((prev) => ({
      ...prev,
      [service.id]: t("pleaseSelectOne")
    }))
    return
  }

  setServiceErrors((prev) => {
    const { [service.id]: removed, ...rest } = prev
    return rest
  })

  setServicesUpdating((prev) => [...new Set([...prev, service.id])])

  const event =
    positionOverride !== null && isSelected
      ? "added" // update position
      : isSelected
      ? "removed"
      : "added"

  const payload = {
    service_definition_id: service.service_id || service.id || service.service_definition_id,
    event,
    prepaid: service.prepaid,
    position
  }

  const opts = {
    isOrder: order && !order.is_tire_order,
    orderId: order && order.id,
    successCallback: async () => {
      trackFirebaseAnalytics({
        event: gaJSON.service_selected,
        params: {
          [gaJSON.services]: [{ ...payload, name: service?.name || "" }],
          [gaJSON.from_where]: window.location.hash,
          [gaJSON.vehicle_name]: vehicle
            ? `${vehicle?.year || ""} ${vehicle?.make?.toUpperCase() || ""} ${
                vehicle?.model?.toUpperCase() || ""
              }`
            : null,
          cartType: cart.cart_type || "scheduled"
        }
      })
    }
  }

  try {
    await updateCart([payload], cart.vehicle_id, undefined, undefined, opts)

    setSelectedServices((prev) =>
      event === "added"
        ? [...new Set([...prev, service.id])]
        : prev.filter((id) => id !== service.id)
    )

    setSelectedPositions((prev) => ({ ...prev, [service.id]: position }))
  } catch (error) {
    console.error("toggleService error:", error)
  } finally {
    setServicesUpdating((prev) => prev.filter((id) => id !== service.id))
  }
}

export default withRouter(
  connect(mapStateToProps, { getCustomServiceCategories, getWalkinServiceCategories, updateCart })(
    SelectService
  )
)
